import React from "react";
import { Button, Stack, Typography } from "@mui/joy";
import { OrganizationIntegration } from "../../common/types";
import { IntegrationCatalogEntry } from "../../types/integrationCatalog";
import SlackInstallButton from "../Integrations/SlackInstallButton";
import IntegrationCardFrame from "./IntegrationCardFrame";
import { isLegacyOAuthAuthorizationCodeEntry } from "./integrationConfigUtils";

interface TierBCardProps {
  entry: IntegrationCatalogEntry;
  integration?: OrganizationIntegration;
  enabled: boolean;
  saving?: boolean;
  onEnable: () => void;
  onEdit: () => void;
  onDisable: () => void;
  onDelete: () => void;
  onTestConnection?: () => void;
  connectionTesting?: boolean;
}

const TierBCard: React.FC<TierBCardProps> = ({
  entry,
  integration,
  enabled,
  saving = false,
  onEnable,
  onEdit,
  onDisable,
  onDelete,
  onTestConnection,
  connectionTesting = false,
}) => {
  const updatedAt = integration?.updated_at || integration?.created_at;
  const updatedBy = integration?.updated_by_email;

  return (
    <IntegrationCardFrame
      entry={entry}
      integration={integration}
      enabled={enabled}
      statusLabel={
        enabled
          ? "Configured"
          : integration?.status === "inactive"
            ? "Disabled"
            : "Not enabled"
      }
      tierBadge="Org-level configuration required"
      metadata={
        updatedAt ? (
          <Typography level="body-xs" color="neutral">
            {updatedBy
              ? `Configured by ${updatedBy} at ${updatedAt}`
              : `Last updated ${updatedAt}`}
          </Typography>
        ) : undefined
      }
      actions={
        enabled && integration ? (
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            {isLegacyOAuthAuthorizationCodeEntry(entry) && (
              <SlackInstallButton
                organizationIntegrationId={integration.id}
                installationStatus={entry.organization_connection_status}
              />
            )}
            {onTestConnection && (
              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                onClick={onTestConnection}
                loading={connectionTesting}
                disabled={saving}
              >
                Test connection
              </Button>
            )}
            <Button
              size="sm"
              variant="outlined"
              color="primary"
              onClick={onEdit}
              disabled={saving}
            >
              Edit
            </Button>
            <Button
              size="sm"
              variant="outlined"
              color="danger"
              onClick={onDisable}
              disabled={saving}
            >
              Disable
            </Button>
            <Button
              size="sm"
              variant="plain"
              color="danger"
              onClick={onDelete}
              disabled={saving}
            >
              Delete configuration
            </Button>
          </Stack>
        ) : (
          <Button
            size="sm"
            variant="solid"
            onClick={onEnable}
            disabled={saving}
          >
            Enable
          </Button>
        )
      }
    />
  );
};

export default TierBCard;
